import { Component, Inject } from '@angular/core';
import { IvyTitleOptions, IvyModalButton, isDefined } from '@crs/ivy';
import { TranslateService } from '@ngx-translate/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Observable, map, combineLatest, takeUntil, timer, of, ReplaySubject, Subject, switchMap } from 'rxjs';

@Component({
  selector: 'app-session-timeout-dialog',
  standalone: false,
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss']
})
export class SessionTimeoutDialogComponent {

  stop: number = 5 * 60 * 1000 - 1000;
  
	message$: Observable<string> = combineLatest([
    this.translate.get('product.logout_in'),
    timer(0, 1000)
  ]).pipe(
    takeUntil(timer(this.stop)),
    map(([msg]) => {
      const minutes = Math.floor((this.stop % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((this.stop % (1000 * 60)) / 1000);
      this.stop -= 1000;
      if(this.stop -1 <= 0){
        this.oktaAuth.signOut();
      }
      return `${msg} ${minutes ? minutes + ':' : '00'+ ':'}${seconds >= 9 ? seconds : '0'+seconds}`;
    })
  );

  title$: Observable<IvyTitleOptions> = this.translate.get('product.user_idle').pipe(
    map(title => {
      return Object.assign({title: title})
    })
  );

  private readonly stopSubject: Subject<number> = new ReplaySubject<number>(1);

  stop$: Observable<number> = this.stopSubject.pipe(
    map((s: number) => {
      if(s <= 0) {
        this.oktaAuth.signOut();
      }
      return s;
    })
  );

  readonly buttons$: Observable<IvyModalButton[]> = combineLatest([
    this.translate.get('product.keep_me_logged_in'),
    this.translate.get('product.logout_btn')
  ]).pipe(
    map(([yesLbl, noLbl]) => {
      return [
        {
          text: yesLbl,
          reason: 'yes',
          buttonClass: 'primary',
          focus: false
        },
      ];
    }
  ));

  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth, private translate: TranslateService) {}
}
